import React from 'react';

const MarketingLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      {children}
    </div>
  );
};

export default MarketingLayout;